import { Button as BaseButton } from '@base-ui/react/button'
import type { ButtonHTMLAttributes, CSSProperties, FC, Ref } from 'react'
import styles from './icon-button.module.css'

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  ref?: Ref<HTMLButtonElement>
  color?: 'default' | 'primary' | 'secondary' | 'error' | 'inherit'
  size?: 'small' | 'medium' | 'large'
  edge?: 'start' | 'end' | false
  href?: string
  target?: string
  rel?: string
}

const colorMap: Record<string, string | undefined> = {
  primary: styles.colorPrimary,
  secondary: styles.colorSecondary,
  error: styles.colorError,
  inherit: styles.colorInherit,
}

const sizeMap: Record<string, string | undefined> = {
  small: styles.sizeSmall,
  large: styles.sizeLarge,
}

const edgeMap: Record<string, string | undefined> = {
  start: styles.edgeStart,
  end: styles.edgeEnd,
}

export const IconButton: FC<IconButtonProps> = ({
  color = 'default',
  size = 'medium',
  edge,
  className,
  href,
  target,
  rel,
  children,
  ...rest
}) => {
  const classes = [styles.iconButton, colorMap[color], sizeMap[size], edge ? edgeMap[edge] : undefined, className]
    .filter(Boolean)
    .join(' ')

  if (href) {
    if (rest.disabled) {
      return (
        <span
          className={classes}
          role="link"
          aria-disabled="true"
          style={{
            ...((rest as Record<string, unknown>).style as CSSProperties),
            opacity: 0.38,
            pointerEvents: 'none',
          }}
        >
          {children}
        </span>
      )
    }
    return (
      <a className={classes} href={href} target={target} rel={rel} role="button" {...(rest as Record<string, unknown>)}>
        {children}
      </a>
    )
  }

  return (
    <BaseButton className={classes} {...rest}>
      {children}
    </BaseButton>
  )
}
